import React, { Fragment, useState, useEffect } from "react";
import { useAreServicesActive } from "../../util/CommonServices";
import { useDispatch, useSelector } from "react-redux";
import * as CSIDActions from "../../store/csid/actions";
import { ICSIDUserStatus } from "../../store/csid/types";
import * as csidUtil from "../../components/csid/csid";
import AlertL3Dialog from "./AlertL3Dialog";
import { ApplicationState } from "../../store";
import RenderIcons from "../../Assets/css/_icons/partner_icon/RenderIcons";

const CreditAuthentication = () => {
    const [isIDFuser, setIsIDFUser] = useState(false);
    const isLoading = useSelector((state: ApplicationState) =>
        state.csidUserStatusState && state.csidUserStatusState.isLoading ? state.csidUserStatusState.isLoading : false
    );
    const getUserCSIDStatus = () => dispatch(CSIDActions.actionCreators.getUserCSIDStatus());
    const csidUserStatus = useSelector((state: ApplicationState) =>
        state.csidUserStatusState && state.csidUserStatusState.csidUserStatus ? state.csidUserStatusState.csidUserStatus : null
    );
    const [showAuthenticatedPage, setShowAuthenticatedPage] = useState(false);
    const [initComplete, setInitComplete] = useState(false);

    const businessProfileStatus = useSelector(
        (state: ApplicationState) =>
            state.loggedInUser &&
            state.loggedInUser.userServiceDetails?.businessProfileStatus?.filter((obj: any) => {
                return obj.provider;
            })
    );
    const creditProvider = businessProfileStatus != null && businessProfileStatus.length > 0 ? businessProfileStatus[0].provider : "";

    const checkShowingAuthenticatedPage = () => {
        let isDisplayable = false;
        if (csidUserStatus) {
            if (csidUserStatus.isIDFUser || csidUserStatus.isTUUser) {
                setIsIDFUser(csidUserStatus.isIDFUser);
                if (csidUserStatus["auth-status"] != null && csidUserStatus["auth-status"].toUpperCase() === "AUTHENTICATED") {
                    isDisplayable = true;
                }
            } else {
                const nextStep: csidUtil.NEXT_STEP = csidUtil.getNextStep(csidUserStatus);
                switch (nextStep) {
                    case csidUtil.NEXT_STEP.GO_TO_DASHBOARD:
                        isDisplayable = true;
                        break;
                    default:
                        break;
                }
            }
        }
        if (initComplete === false) {
            setInitComplete(true);
        }
        return setShowAuthenticatedPage(isDisplayable);
    };

    const dispatch = useDispatch();
    const [showCreditAuth, setShowCreditAuth] = useState(false);
    const isCreditServiceActive = useAreServicesActive([
        "SVC-CRDSCORE-1B",
        "SVC-CRDSCORE-1B-MONTHLY",
        "SVC-CRDRPT",
        "trans-union-credit-monitoring",
        "three-bureau-credit-monitoring",
        "advanced-fraud-monitoring",
        "SVC-BIZ-CREDIT-DB",
    ]);
    const refreshContext = () => dispatch(CSIDActions.actionCreators.componentNeedsRefresh());

    const ezsCreditAuthSuccessCallBack = (callbackObj: any) => {
        getUserCSIDStatus();
        setShowCreditAuth(false);
        refreshContext();
    };

    useEffect(() => {
        getUserCSIDStatus();
    }, []);

    useEffect(() => {
        checkShowingAuthenticatedPage();
    }, [csidUserStatus]);

    const closeDisclosureDialogCallBack = (callbackObj: any) => {
        setShowCreditAuth(false);
        refreshContext();
    };

   
    return (
        <Fragment>
         
            {isCreditServiceActive && creditProvider === "DUNBRADSTREET" && !isLoading && (
                <li>
                    <div className="dashboard-alert-container status-info">
                        <a href="/app/bcredit/get-started">
                            <span className="row">
                                <span className="col-xs col-no-gutter flex-grow-null">
                                    <span className="dashboard-alert-icon">
                                        <RenderIcons iconName="info-circle" />
                                    </span>
                                </span>
                                <span className="col-xs col-no-gutter">
                                    <span className="dashboard-alert-description">
                                        <span className="sr-only">Informative Alert:</span>Activate your credit service by connecting your business profile
                                    </span>
                                </span>
                            </span>
                        </a>
                    </div>
                </li>
            )}

            <AlertL3Dialog
                showCreditAuth={showCreditAuth}
                csidUserStatus={csidUserStatus as ICSIDUserStatus}
                closeDisclosureDialogCallBack={closeDisclosureDialogCallBack}
                creditAuthSuccessCallBack={ezsCreditAuthSuccessCallBack}
                isIDFuser={isIDFuser}
            />
        </Fragment>
    );
};

export default CreditAuthentication;
